export const types = <const>{
	mutations: {
		DOKLAD_ZAKAZNIK_SELECT_MAPPER: 'DOKLAD_ZAKAZNIK_SELECT_MAPPER',
		DOKLAD_VOZIDLO_SELECT_MAPPER: 'DOKLAD_VOZIDLO_SELECT_MAPPER',
	},
};
